import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import React, { useState } from "react";
import PetCardListNew from "../PetCardListNew/PetCardListNew";
import AccordionCustom from "../Accordion/AccordionCustom";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import GenericCarousel from "../SelectableTimes/GenericCarousel";

interface IPetSelectionList{
  petsList: IPetItemResponse[];
  visiblePetsList: IPetItemResponse[];
  currentIndex: number;
  handleNextClick: () => void;
  handlePreviousClick: () => void;
  handlePetSelection: (pet: IPetItemResponse) => void;

}

const PetSelectionList = (
  {
    petsList,
    visiblePetsList,
    currentIndex,
    handleNextClick,
    handlePreviousClick,
    handlePetSelection,
  }
  : IPetSelectionList) => {
  //  config for wellness icon in pet card
  const isDashBoardPetCardBooking = { wellnessIconCoordinates: { x: "25", y: "-15" },
    wellnessIcon: { height: 14, width: 14 } };
  const { selectedPets } = useAppointmentStore();
  const [expanded, setExpanded] = useState(false);
  const names = selectedPets?.map((pet: IPetItemResponse) => pet.name);

  const formatPetNames = (bookingPetsName: string[])=>{
    if (!Array.isArray(bookingPetsName) || bookingPetsName.length === 0) return "(Select one or multiple pets)";

    if (bookingPetsName.length === 1) {
      return bookingPetsName[0];
    } else if (bookingPetsName.length === 2) {
      return `${bookingPetsName[0]} and ${bookingPetsName[1]}`;
    } else if (bookingPetsName.length === 3) {
      return `${bookingPetsName[0]}, ${bookingPetsName[1]} and ${bookingPetsName[2]}`;
    }

    return "";
  };
  const handleChange = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="rounded-lg w-full">
      <AccordionCustom
        title={<p className="text-sm">Booking for: <b>{formatPetNames(names)}</b></p>}
        isExpanded={expanded}
        handleChange={handleChange}
        containerClass={`${(names?.length || expanded) ? "!bg-taupe-1": "!bg-gv-gold-2"} px-3`}>
        {petsList.length > 4 ?
          <GenericCarousel
            currentIndex={currentIndex}
            handleNext={handleNextClick}
            handleBack={handlePreviousClick}
            optionsLength={petsList.length}
            itemsPerPage={4}
          >
            <div
              className={`w-full grid ${petsList.length < 3 ? "grid-rows-1" : "grid-rows-2"} grid-cols-2 gap-3 mb-3`}>
              <PetCardListNew
                petsList={visiblePetsList}
                handlePetSelection={handlePetSelection}
                isDashBoardPetCardBooking={isDashBoardPetCardBooking}
              />
            </div>
          </GenericCarousel> :
          <div className={`w-full grid ${petsList.length < 3 ? "grid-rows-1" : "grid-rows-2"} grid-cols-2 gap-3 mb-3`}>
            <PetCardListNew
              petsList={visiblePetsList}
              handlePetSelection={handlePetSelection}
              isDashBoardPetCardBooking={isDashBoardPetCardBooking}
            />
          </div>}
      </AccordionCustom>
    </div>
  );
};

export default PetSelectionList;
